import Firebase from "./firebase";

var database = Firebase.database();

export const getData = async () => {
  let snapshot = await database.ref("/").once("value");
  snapshot = snapshot.val();
  return snapshot;
};
export const getKategori = async () => {
  let snapshot = await database.ref("/kategori").once("value");
  snapshot = snapshot.val();
  return snapshot;
};
export const getDiplomaci = async () => {
  let snapshot = await database.ref("/diplomaci").once("value");
  snapshot = snapshot.val();
  console.log(snapshot);
  return snapshot;
};
